import { Button,Card,Divider,Stack,Typography } from '@mui/material';
import { useContext,useMemo,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { UserContext } from '../../context/UserContext';
import AttToken from '../../helpers/attToken';
import callAssociateAll from '../../helpers/callAssociateAll';
import { trackEventMatomo } from '../../helpers/matomo';
import Companies from '../../service/Companies';
import queryClient from '../../service/query';

export default function AdmData() {
  const { t } = useTranslation('translation');
  const { changed, setChanged, acessoPlanoDeAcao, userData, saveUserData } = useContext(UserContext);
  const [disable, setDisable] = useState(false);
  const companieService = useMemo(() => new Companies(), []);
  const [loading, setLoading] = useState(false);

  const migraDesmigra = async (migra: boolean) => {
    setLoading(true);
    toast.warn(`${t('settingsPage.AdmData.changingUsageOfTicketsAndNotifications')}`);
    try {
      const token = await AttToken();
      if (!token) throw new Error('Token not found');
      const response = await companieService.ligaDesligaMigracao(token, migra);
      if (typeof response === 'number' || !response) throw new Error('Migration setting was not updated');
      saveUserData({ ...userData, migrado: migra });
      toast.success(`${t('settingsPage.AdmData.ticketsAndNotificationsChanged')}`);
    } catch {
      toast.error('Erro ao alterar a configuração de chamados e notificações.');
    } finally {
      setLoading(false);
    }
  };

  const changeAccessPlan = async (planoDeAcao: boolean) => {
    setLoading(true);
    await toast.promise(async () => {
      const token = await AttToken();
      if (token) {
        const message: { message: string } = await companieService.concedeRetiraAcessoPlanoDeAcao(token, planoDeAcao);
        queryClient.fetchQuery({ queryKey: ['CHECA_ACESSO_PLANO'] });
        return message;
      } else {
        throw new Error('Erro');
      }
    }, {
      pending: `${planoDeAcao ? t('settingsPage.AdmData.grantingAccess') : t('settingsPage.AdmData.denyingAccess')}`,
      success: `${planoDeAcao ? t('settingsPage.AdmData.actionPlansAccessGranted') : t('settingsPage.AdmData.actionPlansAccessDenied')}`,
      error: t('settingsPage.AdmData.failedToGrantAccess')
    });
    setLoading(false);
  };

  return (
    <Card sx={{ width: '100%' }}>
      <Stack direction="column" alignItems='center' justifyContent='flex-start' spacing={2} sx={{ padding: '1em' }}>
        <Button
          onClick={async () => {
            trackEventMatomo('tela de configurações', 'click', 'Button', 'atualiza dados');
            setDisable(true);
            const token = await AttToken();
            if (token) {
              toast.warn(`${t('atualizando')}`);
              try {
                await companieService.atualizar(token);
                toast.success(`${t('settingsPage.AdmData.dataUpdated')}`);
              } catch (err) {
                throw new Error('Error updating data');
              }
            }
            setDisable(false);
          }}
          disabled={disable}
          variant="contained"
          color='success'
        >
          {t('settingsPage.data.att')}
        </Button>
        <Typography color="textDisabled" fontWeight="bold">{t('settingsPage.data.alert')}</Typography>
        <Divider variant='middle' orientation='horizontal' flexItem />
        <Button
          variant="contained"
          color='success'
          onClick={() => {
            trackEventMatomo('tela de configurações', 'click', 'Button', 'associa serviços');
            setChanged(false);
            callAssociateAll();
          }}
          disabled={!changed}
        >
          {t('settingsPage.data.Associate')}
        </Button>
        {changed ? (
          <Typography color="textDisabled" fontWeight="bold">
            {t('settingsPage.data.pressBtn')}
          </Typography>
        ) : (<Typography color="textDisabled" fontWeight="bold">{t('settingsPage.data.NenhumaMudanca')}</Typography>)}
        <Divider variant='middle' orientation='horizontal' flexItem />
        {process.env.REACT_APP_PROJECT_NAME !== 'Axyma Forms' && <>
          {userData?.migrado
            ? <Button
              variant="contained"
              color='success'
              disabled={loading}
              onClick={() => {
                trackEventMatomo('tela de configurações', 'click', 'Button', 'migra chamados');
                migraDesmigra(false);
              }}
            >
              {t('settingsPage.AdmData.returnToLegacyTicketsAndNotifications')}
            </Button>
            : userData.id && <Button
              variant='contained'
              color='success'
              disabled={loading}
              onClick={() => {
                trackEventMatomo('tela de configurações', 'click', 'Button', 'migra chamados');
                migraDesmigra(true);
              }}
            >
              {t('settingsPage.AdmData.useTicketsAndNotifications2_0')}
            </Button>}
        </>}

        {process.env.REACT_APP_PROJECT_NAME !== 'Axyma Forms' && <>
          {acessoPlanoDeAcao
            ? <Button
              variant="contained"
              color='success'
              disabled={loading}
              onClick={() => {
                trackEventMatomo('tela de configurações', 'click', 'Button', 'acesso planos de ação');
                changeAccessPlan(false);
              }}
            >
              {t('settingsPage.AdmData.denyActionPlanAccessForThisCompany_HOMOLOnly')}
            </Button>
            : userData.id && <Button
              variant="contained"
              color='success'
              disabled={loading}
              onClick={() => {
                trackEventMatomo('tela de configurações', 'click', 'Button', 'acesso planos de ação');
                changeAccessPlan(true);
              }}
            >
              {t('settingsPage.AdmData.grantActionPlanAccessForThisCompany_HOMOLOnly')}
            </Button>}
        </>}
      </Stack>
    </Card>
  );
}
